
import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../include/Header";
import Footer from "../include/Footer";
import { CssBaseline, Grid, Container, Button, Box } from "@material-ui/core";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import Alert from "@material-ui/lab/Alert";
import ExportExcelButton from "../utils/ExportExcelButton";

import useBanner from "./useBanner";
import BannerTable from "./BannerTable";
import BannerFormModal from "./BannerformModel";

const drawerWidth = 280;

function Banner() {
  const {
    bannerData, loading, noData,
    openModal, mode, form, setField,
    submitBanner, updateBanner, deleteBanner,
    openAddModal, openEditModal, closeModal,onStatusChange,
    imageErrors, handleLargeImageChange, handleSmallImageChange,

  } = useBanner();

  const [drawerOpen, setDrawerOpen] = React.useState(true);

  return (
    <>
      <Helmet><title>Banner</title></Helmet>
      <Header forwardDrawerOpen={setDrawerOpen} />
      <CssBaseline />

      <div style={{
        paddingTop: "5rem",
        paddingLeft: drawerOpen ? drawerWidth + 15 : 72 + 15,
        transition: "padding 0.5s ease",
      }}>
        <main>
          <Container maxWidth="lg">
            <Box bgcolor="background.paper" mt={2} boxShadow={3}>
              <Alert
                variant="outlined"
                severity="default"
                action={
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddCircleOutlineOutlinedIcon />}
                      onClick={openAddModal}
                    >
                      Add Banner
                    </Button>
                    <ExportExcelButton />
                  </div>
                }
              >
                <h2>Banner</h2>
              </Alert>
            </Box>


            <Grid container spacing={3} align="center">
              <Grid item xs={12}>
                <Box bgcolor="background.paper" boxShadow={3} px={2} py={2} mt={1}>
                  {loading && <p>Loading...</p>}
                  {noData && <p>{noData}</p>}
                  <BannerTable
                    bannerData={bannerData}
                    onEdit={openEditModal}
                    onDelete={deleteBanner}
                    onStatusChange={onStatusChange}

                  />
                </Box>
              </Grid>
            </Grid>

            <Footer />
          </Container>
        </main>
      </div>

      <BannerFormModal
        open={openModal}
        mode={mode}
        form={form}
        imageErrors={imageErrors}
        handleLargeImageChange={handleLargeImageChange}
        handleSmallImageChange={handleSmallImageChange}
        setField={setField}
        onClose={closeModal}
        onSubmit={mode === "edit" ? updateBanner : submitBanner}
      />
    </>
  );
}

export default Banner;
